<template>
  <div>
    <div>
      <el-row>
        <div style="margin-top: 10px; min-height: 200px;">
          <portal to="destinationOP">
            <el-select id="rfcFilter" v-loading="tableLoader" element-loading-spinner="none" key="rfcMulti" v-model="reasonForChangeMultiSelect" placeholder="" :clearable="false" multiple :collapse-tags="true" @visible-change="handleRFCMultiSelect($event)" @remove-tag="handleRFCMultiSelect()">
              <el-option v-for="item in opListMeta.reasonForChangeList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </portal>
          <portal to="responseRequiredLastOP">
            <el-select id="rsFilter" v-loading="tableLoader" element-loading-spinner="none" key="rsMulti" v-model="responseRequiredMultiSelect" placeholder="" :clearable="false" multiple :collapse-tags="true" @visible-change="handleRSMultiSelect($event)" @remove-tag="handleRSMultiSelect()">
              <el-option v-for="item in opListMeta.responseRequiredList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </portal>

          <v-server-table class="hiaTable" ref="coderOutpatientListGrid" id="coderOutpatientListGrid" :columns="columns" :options="options" @loading="tableLoader = true" @loaded="tableLoader = false" v-loading="tableLoader" element-loading-spinner="nucleus-loader">
            <template slot="filter__reasonForChangeDesc">
              <portal-target name="destinationOP"> </portal-target>
            </template>
            <template slot="filter__responseRequiredLast">
              <portal-target name="responseRequiredLastOP"> </portal-target>
            </template>
            <template slot="patientNumber" slot-scope="props">
              <router-link :to="`/${currentClientId}/my-projects/outpatient/${props.row.ascTableId}`">{{ props.row.patientNumber }}</router-link>
            </template>
            <template slot="particleUrl" slot-scope="props">
              <div>
                <a :href="`${compParticleBaseUrl}/reviews/outpatient/${props.row.ascTableId}`" target="_new">{{ props.row.patientNumber }}</a>
              </div>
            </template>

            <template slot="opCoder" slot-scope="props">
              <div :style="index > 0 ? `margin-top: 5px;` : ``" v-for="(coder, index) in props.row.opCoder ? props.row.opCoder.split('|') : []" :key="coder">
                {{ coder }}
              </div>
            </template>

            <template slot="opCodeTypes" slot-scope="props">
              <div :style="index > 0 ? `margin-top: 5px;` : ``" v-for="(codeType, index) in props.row.opCodeTypes ? props.row.opCodeTypes.split(',') : []" :key="codeType">
                {{ codeType }}
              </div>
            </template>

            <template slot="dateOfService" slot-scope="props">
              <div>
                {{ props.row.dateOfService ? formatDate(props.row.dateOfService) : '' }}
              </div>
            </template>
            <template slot="completeDate" slot-scope="props">
              <div>
                {{ props.row.completeDate ? formatDate(props.row.completeDate) : '' }}
              </div>
            </template>
            <template slot="date" slot-scope="props">
              <div>
                {{ props.row.date ? formatDate(props.row.date) : '' }}
              </div>
            </template>
            <template slot="level2ReasonForChange" slot-scope="props">
              <div>
                {{ props.row.reviewLevel !== 'Coding Review' ? props.row.level2ReasonForChange : '' }}
              </div>
            </template>
            <template slot="rebuttalDate" slot-scope="props">
              <div>
                {{ props.row.rebuttalDate ? formatDate(props.row.rebuttalDate) : '' }}
              </div>
            </template>
            <template slot="reviewDate" slot-scope="props">
              <div>
                {{ props.row.reviewDate ? formatDate(props.row.reviewDate) : '' }}
              </div>
            </template>
            <template slot="rebuttalDate" slot-scope="props">
              <div>
                {{ props.row.rebuttalDate ? formatDate(props.row.rebuttalDate) : '' }}
              </div>
            </template>
            <template slot="rebuttalDateLast" slot-scope="props">
              <div>
                {{ props.row.rebuttalDateLast ? formatDate(props.row.rebuttalDateLast) : '' }}
              </div>
            </template>
            <template slot="displayClientName" slot-scope="props">
              <div class="displayClientNameText" :title="props.row.displayClientName">
                {{ props.row.displayClientName }}
              </div>
            </template>
            <template slot="agreeWithCodesLast" slot-scope="props">
              <div style="display: flex; align-items: center;">
                <i v-if="props.row.agreeWithCodesLast" :style="`font-size: 18px;margin-right: 5px;color:${props.row.agreeWithCodesLast === 'Yes' ? `#67c23a` : `#e6a23c;`}`" :class="props.row.agreeWithCodesLast === 'Yes' ? `el-icon-circle-check` : `el-icon-warning-outline`"></i><span>{{ props.row.agreeWithCodesLast }}</span>
              </div>
            </template>
            <template slot="rebuttals" slot-scope="props">
              <div style="display: flex; align-items: center;">
                <i v-if="props.row.rebuttals.length" :style="`cursor: pointer;width: 100%; text-align: center; font-size: 18px;color:${props.row.responseRequiredLast === 'Completed' ? `#67c23a` : `#e6a23c;`}`" :class="props.row.responseRequiredLast === 'Completed' ? `el-icon-chat-line-round` : `el-icon-chat-dot-round`" @click="handleRebuttalDisplayModal(props.row)"></i>
              </div>
            </template>
          </v-server-table>
        </div>
      </el-row>
    </div>
    <div id="dialogs">
      <rebuttalDisplay :record="selectedRecord" :rebuttalDisplayModal="rebuttalDisplayModal" @close="rebuttalDisplayModal = false"></rebuttalDisplay>
      <!-- <coderInpatientWorksheetModal v-if="showWorksheetModal" :ascTableId="worksheetascTableId" :showWorksheetModal="showWorksheetModal" @close="handleModalClose"> </coderInpatientWorksheetModal> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import dateHelper from '@/mixins/date-helper'
import hiaTable from '@/mixins/hiaTable'
import debounce from 'debounce'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import rebuttalDisplay from '@/views/MyProjects/rebuttalDisplay'

export default {
  name: 'inpatientList',
  mixins: [dateHelper, hiaTable, HiaAuthorization],
  data() {
    return {
      reasonForChangeMultiSelect: [],
      reasonForChangeMultiSelectBackup: [],
      responseRequiredMultiSelect: [],
      responseRequiredMultiSelectBackup: [],
      showMassUpdateDialog: false,
      statsLoading: false,
      vueTables2Query: {},
      loading: true,
      showWorksheetModal: false,
      worksheetascTableId: null,
      filterCriteria: '',
      tableLoader: false,
      isActivated: true,
      columns: ['patientNumber', 'particleUrl', 'patientType', 'mrNumber', 'displayClientName', 'consultantNumber', 'payorName', 'opCodeTypes', 'opCoder', 'reasonForChangeDesc', 'dateOfService', 'date', 'agreeWithCodesLast', 'rebuttals', 'responseRequiredLast'],
      options: {
        // see the options API
        actionsPosition: 'right',
        requestFunction: data => {
          return this.requestData(data)
        },
        debounce: 600,
        filterByColumn: true,
        listColumns: {
          reviewLevel: []
        },
        filterable: ['patientNumber', 'particleUrl', 'patientType', 'mrNumber', 'displayClientName', 'consultantNumber', 'payorName', 'opCodeTypes', 'opCoder', 'dateOfService', 'date', 'agreeWithCodesLast', 'rebuttals'],
        columnsClasses: {
          selected: 'selected',
          reasonForChangeDesc: 'reasonForChangeDesc',
          comments: 'customComments',
          delete: 'delete',
          particleUrl: 'hide',
          responseRequiredLast: 'responseRequiredLast',
          displayClientName: 'displayClientName'
        },
        headings: {
          selected: h => {
            return h('input', {
              attrs: {
                type: 'checkbox',
                id: 'selectAllCheckboxOutpatientList'
              },
              on: {
                click: e => {
                  this.selectAll(e.srcElement.checked)
                }
              },
              ref: 'selectAllCheckbox'
            })
          },
          agreeWithCodes: 'Agree with Changes',
          auditResult: 'Audit Result',
          patientNumber: 'Patient Number',
          consultantNumber: 'Consultant Number',
          payorName: 'Payor',
          mrNumber: 'MR Number',
          opCoder: 'Coder',
          patientType: 'Pat Type',
          physicianName: 'Provider',
          dateOfService: 'Date of Service',
          reasonForChangeDesc: 'Reason F Change',
          comments: 'Comments',
          date: 'Review Date',
          responseNeeded: 'Response Needed',
          responseCount: 'Response Count',
          finalOutcome: 'Final Outcome',
          rebuttalDate: 'Response Date',
          agreeWithCodesLast: 'Agree With Findings',
          agreeWithGroupingLast: 'Agree With Grouping',
          responseRequiredLast: 'Response Status',
          rebuttalDateLast: 'Response Date',
          codesStatusLast: 'Codes Outcome',
          groupingStatusLast: 'Grouping Outcome',
          delete: '',
          particleUrl: 'Particle URL',
          opCodeTypes: 'Code Types',
          displayClientName: 'Facility',
          rebuttals: 'View Rebuttals'
        },
        perPage: 25,
        texts: {
          filter: '',
          filterBy: '...'
        },
        highlightMatches: true,
        sortIcon: { is: 'none' }
      },
      selectedRecord: [],
      rebuttalDisplayModal: false
    }
  },
  methods: {
    ...mapActions('myProjects/', ['LOAD_REBUTTALS_OP_LIST_PAGINATED', 'RUN_OP_MASS_ACKNOWLEDGE_NO_CHANGES']),
    ...mapActions('dropdowns/', ['GET_DROPDOWNS', 'CONVERT_DROPDOWN_COLUMNFILTERARRAY']),
    ...mapMutations('outpatientReviews/', ['SET_OUTPATIENTLIST_SELECTED', 'CLEAR_OUTPATIENTLIST_SELECTED', 'SET_OUTPATIENTLIST_REFRESH_FUNC']),
    async requestData(data) {
      try {
        data.projectID = this.$route.params.id
        data.query.projectID = this.$route.params.id
        data.query.reasonForChangeMultiSelect = this.reasonForChangeMultiSelect
        data.query.responseRequiredMultiSelect = this.responseRequiredMultiSelect
        data.globalSearch = this.filterCriteria
        this.vueTables2Query = data
        this.statsLoading = true
        const resultArray = await this.LOAD_REBUTTALS_OP_LIST_PAGINATED(data)
        this.options.columnsClasses.particleUrl = this.documentManagerAdmin() ? '' : 'hide'
        this.statsLoading = false
        return resultArray
      } catch (err) {
        console.log(err)
      }
    },
    getSelectedRecords() {
      const simpleArray = this.opListSelected.map(y => y.ascTableId)
      return [...new Set(simpleArray)]
    },
    async localSelectAll(checked) {
      const table = this.$refs.ipReviewListGrid.$el
      const checkboxes = table.querySelectorAll('input[type ="checkbox"]')

      if (checked) {
        this.tableLoader = true
        await this.GET_OUTPATIENT_LIST_ALLIDS(this.vueTables2Query)
        for (let i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = true
        }
        this.tableLoader = false
        // this.$refs.ipReviewListGrid.refresh()
      } else {
        this.CLEAR_OUTPATIENTLIST_SELECTED()
        for (let i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = false
        }
        // this.$refs.ipReviewListGrid.refresh()
      }
    },
    runGlobalFilter: debounce(function() {
      this.$refs.coderOutpatientListGrid.getData()
    }, 400),
    async handleMassUpdate(massUpdateModel) {
      this.showMassUpdateDialog = false
      // this.localSelectAll(false) // clear all the selected checkboxes
      // this.$refs.ipReviewListGrid.getData()
    },
    handleRFCMultiSelect(isOpenEvent) {
      if (isOpenEvent === true) {
        this.reasonForChangeMultiSelectBackup = JSON.parse(JSON.stringify(this.reasonForChangeMultiSelect))
        return
      }

      if (JSON.stringify(this.reasonForChangeMultiSelectBackup) !== JSON.stringify(this.reasonForChangeMultiSelect)) {
        this.$refs.coderOutpatientListGrid.getData()
        this.reasonForChangeMultiSelectBackup = JSON.parse(JSON.stringify(this.reasonForChangeMultiSelect))
      }
    },
    handleRSMultiSelect(isOpenEvent) {
      if (isOpenEvent === true) {
        this.responseRequiredMultiSelectBackup = JSON.parse(JSON.stringify(this.responseRequiredMultiSelect))
        return
      }

      if (JSON.stringify(this.responseRequiredMultiSelectBackup) !== JSON.stringify(this.responseRequiredMultiSelect)) {
        this.$refs.coderOutpatientListGrid.getData()
        this.responseRequiredMultiSelectBackup = JSON.parse(JSON.stringify(this.responseRequiredMultiSelect))
      }
    },
    runAcknowledgeNoChanges() {
      this.$confirm('Acknowledge No Changes for records without changes?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const payload = {
          projectID: this.$route.params.id,
          outpatientGrouperId: 1,
          rebuttalDate: new Date().toISOString()
        }
        this.tableLoader = true
        this.RUN_OP_MASS_ACKNOWLEDGE_NO_CHANGES(payload).then(
          () => {
            this.$refs.coderOutpatientListGrid.getData()
            this.tableLoader = false
            this.$message({
              message: 'Acknowledge No Changes Successful',
              type: 'success'
            })
          },
          error => {
            console.log(error)
            this.tableLoader = false
            const message = error.response.data.message || 'Acknowledge No Changes Error'
            this.$message({
              message: message,
              type: 'error'
            })
          }
        )
      })
    },
    handleRebuttalDisplayModal(row) {
      this.selectedRecord = row
      this.rebuttalDisplayModal = true
    }
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientName', 'currentClientId', 'clients', 'user']),
    ...mapState('outpatientReviews/', ['statistics', 'opListSelected', 'opListRecordValidations']),
    ...mapState('projects/', ['projectPK', 'project']),
    ...mapState('dropdowns/', ['dropdowns']),
    ...mapState('myProjects/', ['opListStatistics', 'opListMeta']),
    compParticleBaseUrl() {
      return process.env.VUE_APP_PARTICLE_BASE_URL
    }
  },
  created: function() {
    // this.defaultColumns = JSON.parse(JSON.stringify(this.sortableColumns))
    // this.loading = true
  },
  mounted: function() {
    if (this.$route.query.id) {
      this.openWorksheetModal({ ascTableId: this.$route.query.id })
    }
  },
  activated: function() {
    if (this.$refs.coderOutpatientListGrid && !this.isActivated) {
      this.$refs.coderOutpatientListGrid.getData()
    }
    this.isActivated = true
  },
  deactivated: function() {
    this.isActivated = false
    this.localInpatientReviews = []
    // clear any old validation messages, validation messages can be left around because the form validation gets triggered natively by
    // the browser when users hit the enter key in the form
    if (this.$refs.addForm) {
      this.$refs.addForm.clearValidate()
    }
    // this.localSelectAll(false)
    // this.CLEAR_OUTPATIENTLIST_SELECTED()
  },
  components: {
    rebuttalDisplay
  }
}
</script>

<style scoped>
.item {
  margin-top: 3px;
  margin-right: 35px;
}

.stats-loading {
  opacity: 0.5;
}

.stats .el-tag {
  background-color: transparent !important;
  color: #909399 !important;
  border-color: #e9e9eb !important;
}

.stats >>> .el-badge__content {
  background-color: #f4f4f5 !important;
  color: #303133 !important;
}

>>> .reasonForChangeDesc,
>>> .responseRequiredLast {
  min-width: 145px;
}

>>> .reasonForChangeDesc .el-tag,
>>> .responseRequiredLast .el-tag {
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>> .rfcFilter {
}

>>> .hide {
  display: none !important;
}

>>> .displayClientName {
  max-width: 100px;
}

>>> .displayClientNameText {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
